import type { OversightAssessmentRiskAssessmentResultsByRiskIdResponse } from '@risksmart-app/trpc/src/types';
import type { GetOversightAssessmentRiskAssessmentResultsByRiskIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetOversightAssessmentRiskAssessmentResultsByRiskIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createLazyQueryHook } from 'src/utils';

type UseLazyGetOversightAssessmentRiskAssessmentResultsByRiskIdArgs = {
  riskId: string;
};

export const useLazyGetOversightAssessmentRiskAssessmentResultsByRiskId =
  createLazyQueryHook<
    UseLazyGetOversightAssessmentRiskAssessmentResultsByRiskIdArgs,
    OversightAssessmentRiskAssessmentResultsByRiskIdResponse,
    GetOversightAssessmentRiskAssessmentResultsByRiskIdQuery
  >({
    trpcQuery: (client, { riskId }) =>
      client.frontend.assessment.oversightAssessmentRiskAssessmentResultsByRiskId.query(
        { riskId }
      ),
    mapTrpcDataToGraphQL: (data) => ({
      risk_controlled_oversight_result: data.risk_controlled_second_line_result,
      risk_uncontrolled_oversight_result:
        data.risk_uncontrolled_second_line_result,
    }),
    graphqlDocument:
      GetOversightAssessmentRiskAssessmentResultsByRiskIdDocument,
    graphqlVariables: ({ riskId }) => ({ RiskId: riskId }),
  });
